import React from 'react';
import ReactDOM from 'react-dom';
import Route from './Route';
import { Provider } from 'mobx-react';
import store from './store'; 
import './index.scss';

ReactDOM.render(
    <Provider
        store={store}
    >
        <Route />
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js